import { useEffect, useState, useRef } from "react";
import ScatterChart from "./ScatterChart";
import { useLocation, useNavigate } from "react-router-dom";
import { formatDateToShortString, formatDecimalPercentage, getColorFromSegment } from "../../../../common/common";
import { toast } from "react-toastify";
import AtRisk from "./atRisk";
import Chart from "chart.js/auto";
import ChartsDashboard from "./newChart";
import CustomerSegmentationTable from "./CustomerSegmentationTable";


const clusterLabels = [
    { name: 'Champions', color: 'bg-green-500' },
    { name: 'Loyalists', color: 'bg-blue-500' },
    { name: 'Potential', color: 'bg-orange-500' },
    { name: 'New', color: 'bg-purple-500' },
    { name: 'At Risk', color: 'bg-red-500' },
    { name: 'Hibernating', color: 'bg-gray-400' },
    { name: 'Others', color: 'bg-gray-300' }
];

const Kmeans = ({ rfmResponsePrev }) => {
    const segmentChartRef = useRef(null);
    const location = useLocation();
    const { order_details_id, reportId, start_date, end_date } = location.state || {};
    const [isLoading, setIsloading] = useState(false);
    const [rfmResponse, setRfmResponse] = useState([]);
    const [filterRfmResponse, setFilterRfmResponse] = useState([]);
    const [filterRfmResponseForSegment, setFilterRfmResponseForSegment] = useState([]);
    const [blockValue, setBlockValue] = useState({})
    const [analysisDate,setAnalysisDate] = useState("")
    const [page, setPage] = useState(1);
    const [limit,setLimit] = useState(9);
    const [total, setTotal] = useState(0);
    const [searchQuery, setSearchQuery] = useState('');
    const [debouncedSearch, setDebouncedSearch] = useState('');
    const typingTimeoutRef = useRef(null);
    const [sortBy,setSortBy] = useState('');
    const [segmentFilter, setSegmentFilter] = useState('');

    const [blockData, setBlockData] = useState({
        champions: {
            totalCustomers: 0,
            totalRevenue: 0,
            avgRevenue: 0,
            percentage: 0
        },
        loyalists: {
            totalCustomers: 0,
            totalRevenue: 0,
            avgRevenue: 0,
            percentage: 0

        },
        potential: {
            totalCustomers: 0,
            totalRevenue: 0,
            avgRevenue: 0,
            percentage: 0
        },
        new: {
            totalCustomers: 0,
            totalRevenue: 0,
            avgRevenue: 0,
            percentage: 0
        },
        atRisk: {
            totalCustomers: 0,
            totalRevenue: 0,
            avgRevenue: 0,
            percentage: 0
        },
        hibernating: {
            totalCustomers: 0,
            totalRevenue: 0,
            avgRevenue: 0,
            percentage: 0
        },
        others: {
            totalCustomers: 0,
            totalRevenue: 0,
            avgRevenue: 0,
            percentage: 0
        },

    })
    const [subTabs, setSubtabs] = useState("all")
    const [totalCustomers, setTotalCustomers] = useState(0)

    const navigate = useNavigate()

    const getCustomerSegmentaions = async () => {
        try {
            setIsloading(true);
            let url = `${process.env.REACT_APP_API_END_POINT}/order/k-means-clustering?order_details_id=${order_details_id}&page=${page}&limit=${limit}&sortBy=${sortBy}&segmentFilter=${segmentFilter}&searchQuery=${searchQuery}`
            const response = await fetch(
                url,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                }
            );

            const dataN = await response.json();
            if (!response.ok) {
                if (dataN.detail?.isExpireToken) {
                    localStorage.removeItem("token");
                    localStorage.removeItem("userInfo");
                    navigate("/login");
                }
                throw new Error(dataN.detail?.message || "Failed to fetch customer segments");
            }

            setTotal(dataN.total);  // Total count for pagination
            setPage(dataN.page);    // Current page
            setLimit(dataN.limit);  // Current limit
            setAnalysisDate(dataN.calendar_insights.createdAt)
            let count = []
            const customers = dataN.rfm_scores.map((cust) => {
                const total_spent = parseFloat(cust.total_spent || 0); // fallback if value is missing
                return ({
                    name: cust.customer_name?.trim() == "" || cust.customer_name == null ? 'N/A' : cust.customer_name,
                    email: cust.customerEmail,
                    initials: cust.customer_name?.trim() == "" || cust.customer_name == null ? 'N/A' : cust.customer_name
                        .split(' ')
                        .map((n) => n[0])
                        .join('')
                        .toUpperCase(),
                    color: getColorFromSegment(cust.segment), // You'll define this function below
                    scores: {
                        R: cust.R_score,
                        F: cust.F_score,
                        M: cust.M_score,
                    },
                    total_spent: total_spent,
                    recency: `${cust.recency_days} days`,
                    recency_days: cust.recency_days,
                    totalSpent: `$${cust.total_spent.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
                    orders: cust.order_count,
                    segment: cust.segment,
                    segmentColor: getColorFromSegment(cust.segment),
                })
            });
            // console.log(dataN.rfm_scores,customers,"customers")
            setRfmResponse(dataN.rfm_scores)
            setFilterRfmResponse(customers)



        } catch (err) {
            toast.error(err.message, {
                position: "top-right",
                autoClose: 3000,
            });
        } finally {
            setIsloading(false);
        }
    };

    const getCustomerSegmentaionsInformations = async () => {
        try {
            // setIsloading(true);
            let url = `${process.env.REACT_APP_API_END_POINT}/order/customer-segmetaions-informations?order_details_id=${order_details_id}`
            const response = await fetch(
                url,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                }
            );

            const dataN = await response.json();
            if (!response.ok) {
                if (dataN.detail?.isExpireToken) {
                    localStorage.removeItem("token");
                    localStorage.removeItem("userInfo");
                    navigate("/login");
                }
                throw new Error(dataN.detail?.message || "Failed to fetch customer segments");
            }

            setBlockData(dataN.block_data)
            setBlockValue(dataN.block_value)
            setTotalCustomers(dataN.block_value.totalCustomers)

        } catch (err) {
            toast.error(err.message, {
                position: "top-right",
                autoClose: 3000,
            });
        } finally {
            // setIsloading(false);
        }
    };

    useEffect(()=>{
        getCustomerSegmentaionsInformations()
    },[])

    // 🟡 Debounce the search term (500ms)
    useEffect(() => {
      if (typingTimeoutRef.current) {
        clearTimeout(typingTimeoutRef.current);
      }
    
      typingTimeoutRef.current = setTimeout(() => {
        setDebouncedSearch(searchQuery); // trigger search
        setPage(1); // reset page on new search
      }, 1000);
    
      return () => clearTimeout(typingTimeoutRef.current);
    }, [searchQuery]);




    useEffect(() => {
        // if (rfmResponsePrev.length > 0 && rfmResponse.length === 0) {
            getCustomerSegmentaions();
        // }
    }, [page,sortBy,debouncedSearch,segmentFilter]);


    useEffect(() => {

        const filterResponse = filterRfmResponse
            // Segment filter: match selected segment
            .filter((cust) => {
                // console.log(cust,"iiii","Loyalist")
                let segmentFilter =
                    subTabs === "atRisk" ? "At Risk" :
                        subTabs === "champions" ? "Champion" :
                            subTabs === "potential" ? "Potential" :
                                subTabs === "hibernating" ? "Hibernating" :
                                    subTabs === "others" ? "Others" :
                                        subTabs === "new" ? "New" :
                                            subTabs === "loyalists" ? "Loyalist" : "sds"

                // console.log(segmentFilter,cust.segment === segmentFilter,subTabs)

                return cust.segment === segmentFilter
            })
        setFilterRfmResponseForSegment(filterResponse)
    }, [subTabs])


    if (isLoading) {
        return (
            <div className="flex items-center justify-center h-screen bg-gray-50">
                <div className="flex flex-col items-center">
                    <div className="w-12 h-12 border-4 border-blue-500 border-t-transparent rounded-full animate-spin mb-4" />
                    <h1 className="text-xl font-medium text-gray-700">Loading, please wait...</h1>
                </div>
            </div>
        );
    }

    return (
        <>
            <div class=" px-4 py-6">
                {
                    subTabs === "all" &&
                    <>
                        <section class="mb-8">
                            <section class="mb-12">
                                <div class="flex justify-between items-center mb-6">
                                    <h2 class="text-xl md:text-2xl font-semibold text-gray-800"> Overview</h2>
                                    {/* <div class="flex items-center space-x-2">
                                        <span class="text-sm text-gray-600">Analysis Date:</span>
                                        <span class="bg-purple-100 text-purple-800 px-2 py-1 rounded text-sm">{formatDateToShortString(analysisDate) }</span>
                                    </div> */}
                                    <div class="flex items-center space-x-2">
                                        <span class="text-sm text-gray-600">RFM Dimensions:</span>
                                        <span class="bg-purple-100 text-purple-800 px-2 py-1 rounded text-sm">Recency</span>
                                        <span class="bg-green-100 text-green-800 px-2 py-1 rounded text-sm">Frequency</span>
                                        <span class="bg-yellow-100 text-yellow-800 px-2 py-1 rounded text-sm">Monetary</span>
                                    </div>
                                    
                                </div>

                                <div class="bg-white rounded-xl shadow-md p-6 mb-6 shine">
                                    <div class="flex flex-wrap justify-between items-center">
                                        <div class="flex items-center mb-4 md:mb-0">
                                            <div class="p-3 bg-blue-100 rounded-full mr-4">
                                                <i class="fas fa-users text-blue-600 text-xl"></i>
                                            </div>
                                            <div>
                                                <p class="text-gray-500 text-sm">Total Customers</p>
                                                <h3 class="text-2xl font-bold">{blockValue.totalCustomers?.toLocaleString('en-US')}</h3>
                                            </div>
                                        </div>
                                        <div class="flex items-center mb-4 md:mb-0">
                                            <div class="p-3 bg-green-100 rounded-full mr-4">
                                                <i class="fas fa-shopping-cart text-green-600 text-xl"></i>
                                            </div>
                                            <div>
                                                <p class="text-gray-500 text-sm">Total Orders</p>
                                                <h3 class="text-2xl font-bold">{blockValue.totalOrders?.toLocaleString('en-US')}</h3>
                                            </div>
                                        </div>
                                        {/* <div class="flex items-center mb-4 md:mb-0">
                                            <div class="p-3 bg-purple-100 rounded-full mr-4">
                                                <i class="fas fa-chart-line text-purple-600 text-xl"></i>
                                            </div>
                                            <div>
                                                <p class="text-gray-500 text-sm">Total Revenue</p>
                                                <h3 class="text-2xl font-bold">${blockValue.totalRevenue?.toLocaleString('en-US')}</h3>
                                            </div>
                                        </div> */}
                                        <div class="flex items-center">
                                            <div class="p-3 bg-yellow-100 rounded-full mr-4">
                                                <i class="fas fa-money-check-dollar text-yellow-600 text-xl"></i>
                                            </div>
                                            <div>
                                                <p class="text-gray-500 text-sm">Highest Spent </p>
                                                <h3 class="text-2xl font-bold">${blockValue.highestSpent?.toLocaleString('en-US') ?? '0'}</h3>
                                            </div>
                                        </div>
                                        <div class="flex items-center">
                                    <div class="p-3 bg-blue-100 rounded-full mr-4">
                                        <i class="fas fa-chart-line text-blue-600 text-xl"></i>
                                    </div>
                                    <div>
                                        <p class="text-gray-500 text-sm">Analysis Date</p>
                                        <h3 class="text-2xl font-bold text-blue-800">{formatDateToShortString(analysisDate)}</h3>
                                    </div>
                                    </div>
                                        {/* <div class="flex items-center">
                                            <div class="p-3 bg-yellow-100 rounded-full mr-4">
                                                <i class="fas fa-calendar-alt text-yellow-600 text-xl"></i>
                                            </div>
                                            <div>
                                                <p class="text-gray-500 text-sm">Highest Day </p>
                                                <h3 class="text-2xl font-bold">{blockValue.highestDays?.toLocaleString('en-US')}</h3>
                                            </div>
                                        </div> */}
                                        {/* <div class="flex items-center">
                                            <div class="p-3 bg-yellow-100 rounded-full mr-4">
                                                <i class="fas fa-calendar-alt text-yellow-600 text-xl"></i>
                                            </div>
                                            <div>
                                                <p class="text-gray-500 text-sm">Lowest Day </p>
                                                <h3 class="text-2xl font-bold">{blockValue.lowestDays?.toLocaleString('en-US')}</h3>
                                            </div>
                                        </div> */}
                                    </div>
                                </div>

                                <div class="bg-white rounded-xl shadow-md p-6 mb-8">
                                    <div class="flex flex-col lg:flex-row">


                                        <div class="w-full lg:w-1/2">
                                            <h3 class="text-lg font-semibold mb-4">Cluster Summary</h3>
                                            <div class="grid grid-cols-2 gap-4">

                                                <div class="p-6 bg-gradient-to-r from-green-50 to-green-100 rounded-2xl shadow-lg ring-1 ring-green-200">
                                                    <div class="flex items-center justify-between">
                                                        <h3 class="text-lg font-semibold text-green-800">Champions</h3>
                                                        <span class="inline-flex items-center bg-green-100 text-green-800 text-xs font-semibold px-2 py-1 rounded-full">
                                                            🟢 High Value
                                                        </span>
                                                    </div>
                                                    <div class="mt-4">
                                                        <p class="text-4xl font-bold text-gray-900">
                                                            {blockData.champions.totalCustomers.toLocaleString('en-US')} <span class="text-base font-medium text-gray-500">Customers</span>
                                                        </p>
                                                        <p class="mt-2 text-sm text-gray-600">
                                                            Total Revenue: <span class="font-semibold text-green-700">${blockData.champions.totalRevenue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                                                        </p>
                                                        <p class="mt-2 text-sm text-gray-600">
                                                            Avg Revenue: <span class="font-semibold text-green-700">${blockData.champions.avgRevenue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                                                        </p>
                                                    </div>
                                                    <div class="mt-4">
                                                        <p class="text-xs uppercase tracking-wide text-gray-500">
                                                            High value customers
                                                        </p>
                                                    </div>
                                                </div>

                                                <div class="p-6 bg-gradient-to-l from-indigo-50 to-indigo-100 rounded-2xl shadow-lg ring-1 ring-green-200">
                                                    <div class="flex items-center justify-between">
                                                        <h3 class="text-lg font-semibold text-indigo-800">Loyalists</h3>
                                                        <span class="inline-flex items-center bg-indigo-100 text-indigo-800 text-xs font-semibold px-2 py-1 rounded-full">
                                                            🔵 Moderate
                                                        </span>
                                                    </div>
                                                    <div class="mt-4">
                                                        <p class="text-4xl font-bold text-gray-900">
                                                            {blockData.loyalists.totalCustomers.toLocaleString('en-US')} <span class="text-base font-medium text-gray-500">Customer</span>
                                                        </p>
                                                        <p class="mt-2 text-sm text-gray-600">
                                                            Total Revenue: <span class="font-semibold text-indigo-700">${blockData.loyalists.totalRevenue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                                                        </p>
                                                        <p class="mt-2 text-sm text-gray-600">
                                                            Avg Revenue: <span class="font-semibold text-indigo-700">${blockData.loyalists.avgRevenue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                                                        </p>
                                                    </div>
                                                    <div class="mt-4">
                                                        <p class="text-xs uppercase tracking-wide text-gray-500">
                                                            Regular customers
                                                        </p>
                                                    </div>
                                                </div>

                                                <div class="p-6 bg-gradient-to-l from-orange-50 to-orange-100 rounded-2xl shadow-lg ring-1 ring-green-200">
                                                    <div class="flex items-center justify-between">
                                                        <h3 class="text-lg font-semibold text-orange-800">Potential</h3>
                                                        <span class="inline-flex items-center bg-orange-100 text-orange-800 text-xs font-semibold px-2 py-1 rounded-full">
                                                            🟠 Emerging
                                                        </span>
                                                    </div>
                                                    <div class="mt-4">
                                                        <p class="text-4xl font-bold text-gray-900">
                                                            {blockData.potential.totalCustomers.toLocaleString('en-US')} <span class="text-base font-medium text-gray-500">Customers</span>
                                                        </p>
                                                        <p class="mt-2 text-sm text-gray-600">
                                                            Total Revenue: <span class="font-semibold text-orange-700">${blockData.potential.totalRevenue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                                                        </p>
                                                        <p class="mt-2 text-sm text-gray-600">
                                                            Avg Revenue: <span class="font-semibold text-orange-700">${blockData.potential.avgRevenue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                                                        </p>
                                                    </div>
                                                    <div class="mt-4">
                                                        <p class="text-xs uppercase tracking-wide text-gray-500">
                                                            Growth opportunities
                                                        </p>
                                                    </div>
                                                </div>
                                                <div class="p-6 bg-gradient-to-l  from-purple-50 to-purple-100 rounded-2xl shadow-lg ring-1 ring-green-200">
                                                    <div class="flex items-center justify-between">
                                                        <h3 class="text-lg font-semibold text-purple-800">New</h3>
                                                        <span class="inline-flex items-center bg-purple-100 text-purple-800 text-xs font-semibold px-2 py-1 rounded-full">
                                                            🟣 New                                  </span>
                                                    </div>
                                                    <div class="mt-4">
                                                        <p class="text-4xl font-bold text-gray-900">
                                                            {blockData.new.totalCustomers.toLocaleString('en-US')} <span class="text-base font-medium text-gray-500">Customer</span>
                                                        </p>
                                                        <p class="mt-2 text-sm text-gray-600">
                                                            Total Revenue: <span class="font-semibold text-purple-700">${blockData.new.totalRevenue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                                                        </p>
                                                        <p class="mt-2 text-sm text-gray-600">
                                                            Avg Revenue: <span class="font-semibold text-purple-700">${blockData.new.avgRevenue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                                                        </p>
                                                    </div>
                                                    <div class="mt-4">
                                                        <p class="text-xs uppercase tracking-wide text-gray-500">
                                                            Recent acquisitions
                                                        </p>
                                                    </div>
                                                </div>
                                                <div class="p-6 bg-gradient-to-l  from-red-50 to-red-100 rounded-2xl shadow-lg ring-1 ring-green-200">
                                                    <div class="flex items-center justify-between">
                                                        <h3 class="text-lg font-semibold text-red-800">At Risk</h3>
                                                        <span class="inline-flex items-center bg-red-100 text-red-800 text-xs font-semibold px-2 py-1 rounded-full">
                                                            🔴 Critical     </span>
                                                    </div>
                                                    <div class="mt-4">
                                                        <p class="text-4xl font-bold text-gray-900">
                                                            {blockData.atRisk.totalCustomers.toLocaleString('en-US')} <span class="text-base font-medium text-gray-500">Customer</span>
                                                        </p>
                                                        <p class="mt-2 text-sm text-gray-600">
                                                            Total Revenue: <span class="font-semibold text-red-700">${blockData.atRisk.totalRevenue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                                                        </p>
                                                        <p class="mt-2 text-sm text-gray-600">
                                                            Avg Revenue: <span class="font-semibold text-red-700">${blockData.atRisk.avgRevenue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                                                        </p>
                                                    </div>
                                                    <div class="mt-4">
                                                        <p class="text-xs uppercase tracking-wide text-gray-500">
                                                            Needing attention
                                                        </p>
                                                    </div>
                                                </div>
                                                <div class="p-6 bg-gradient-to-l  from-pink-50 to-pink-100 rounded-2xl shadow-lg ring-1 ring-green-200">
                                                    <div class="flex items-center justify-between">
                                                        <h3 class="text-lg font-semibold text-pink-800">Hibernating</h3>
                                                        <span class="inline-flex items-center bg-pink-100 text-pink-800 text-xs font-semibold px-2 py-1 rounded-full">
                                                            🔴 Critical     </span>
                                                    </div>
                                                    <div class="mt-4">
                                                        <p class="text-4xl font-bold text-gray-900">
                                                            {blockData.hibernating.totalCustomers.toLocaleString('en-US')} <span class="text-base font-medium text-gray-500">Customer</span>
                                                        </p>
                                                        <p class="mt-2 text-sm text-gray-600">
                                                            Total Revenue: <span class="font-semibold text-pink-700">${blockData.hibernating.totalRevenue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                                                        </p>
                                                        <p class="mt-2 text-sm text-gray-600">
                                                            Avg Revenue: <span class="font-semibold text-pink-700">${blockData.hibernating.avgRevenue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                                                        </p>
                                                    </div>
                                                    <div class="mt-4">
                                                        <p class="text-xs uppercase tracking-wide text-gray-500">
                                                            Inactive customers
                                                        </p>
                                                    </div>
                                                </div>
                                                <div class="p-6 bg-gradient-to-l  from-gray-50 to-gray-100 rounded-2xl shadow-lg ring-1 ring-green-200 col-span-2">
                                                    <div class="flex items-center justify-between">
                                                        <h3 class="text-lg font-semibold text-gray-800">Others</h3>
                                                        <span class="inline-flex items-center bg-gray-100 text-gray-800 text-xs font-semibold px-2 py-1 rounded-full">
                                                            ⚪ General</span>
                                                    </div>
                                                    <div class="mt-4">
                                                        <p class="text-4xl font-bold text-gray-900">
                                                            {blockData.others.totalCustomers.toLocaleString('en-US')} <span class="text-base font-medium text-gray-500">Customers</span>
                                                        </p>
                                                        <p class="mt-2 text-sm text-gray-600">
                                                            Avg Revenue: <span class="font-semibold text-gray-700">${blockData.others.avgRevenue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                                                        </p>
                                                    </div>
                                                    <div class="mt-4">
                                                        <p class="text-xs uppercase tracking-wide text-gray-500">
                                                            Unclassified patterns
                                                        </p>
                                                    </div>
                                                </div>


                                            </div>
                                        </div>


                                        <div class="w-full lg:w-1/2 mb-8 lg:mb-0">
                                            <div class="w-full">
                                                <CustomerSegmentationTable subTabs={subTabs} rfmResponse={rfmResponse} filterRfmResponse={filterRfmResponse} page={page} limit={limit} total={total} setPage={setPage} searchQuery={searchQuery} setSearchQuery={setSearchQuery} segmentFilter={segmentFilter} setSegmentFilter={setSegmentFilter} sortBy={sortBy} setSortBy={setSortBy} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </section>

                        <section class="mb-8">
                            <div class="flex flex-col md:flex-row gap-6">



                                {/* <div class="w-full md:w-2/3">
                            <div class="bg-white rounded-xl shadow-sm p-6">
                                <div class="flex justify-between items-center mb-4">
                                    <h2 class="text-xl font-semibold text-gray-800">Action Recommendations</h2>
                                    <button class="flex items-center gap-1 text-turq-500 hover:text-turq-600 font-medium">
                                        <i class="fas fa-list"></i> View Customer List
                                    </button>
                                </div>
                                <div class="overflow-x-auto">
                                    <table class="min-w-full divide-y divide-gray-200">
                                        <thead class="bg-gray-50">
                                            <tr>
                                                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Cluster</th>
                                                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Recommendation</th>
                                                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Potential Revenue Uplift</th>
                                                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Suggested Products</th>
                                            </tr>
                                        </thead>
                                        <tbody class="bg-white divide-y divide-gray-200">
                                            <tr>
                                                <td class="px-6 py-4 whitespace-nowrap">
                                                    <div class="flex items-center">
                                                        <div class="w-3 h-3 rounded-full bg-green-500 mr-2"></div>
                                                        <div class="text-sm font-medium text-gray-900">Champions</div>
                                                    </div>
                                                </td>
                                                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-700">Premium Upsell</td>
                                                <td class="px-6 py-4 whitespace-nowrap">
                                                    <span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">+18%</span>
                                                </td>
                                                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-700">Product A, Product B</td>
                                            </tr>
                                            <tr>
                                                <td class="px-6 py-4 whitespace-nowrap">
                                                    <div class="flex items-center">
                                                        <div class="w-3 h-3 rounded-full bg-blue-500 mr-2"></div>
                                                        <div class="text-sm font-medium text-gray-900">Loyalists</div>
                                                    </div>
                                                </td>
                                                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-700">Loyalty Program Expansion</td>
                                                <td class="px-6 py-4 whitespace-nowrap">
                                                    <span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">+12%</span>
                                                </td>
                                                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-700">Product C, D</td>
                                            </tr>
                                            <tr>
                                                <td class="px-6 py-4 whitespace-nowrap">
                                                    <div class="flex items-center">
                                                        <div class="w-3 h-3 rounded-full bg-orange-500 mr-2"></div>
                                                        <div class="text-sm font-medium text-gray-900">Potential</div>
                                                    </div>
                                                </td>
                                                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-700">Starter Bundle Offer</td>
                                                <td class="px-6 py-4 whitespace-nowrap">
                                                    <span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">+10%</span>
                                                </td>
                                                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-700">Product E</td>
                                            </tr>
                                            <tr>
                                                <td class="px-6 py-4 whitespace-nowrap">
                                                    <div class="flex items-center">
                                                        <div class="w-3 h-3 rounded-full bg-purple-500 mr-2"></div>
                                                        <div class="text-sm font-medium text-gray-900">New</div>
                                                    </div>
                                                </td>
                                                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-700">Onboarding Offer</td>
                                                <td class="px-6 py-4 whitespace-nowrap">
                                                    <span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">+8%</span>
                                                </td>
                                                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-700">Product F</td>
                                            </tr>
                                            <tr>
                                                <td class="px-6 py-4 whitespace-nowrap">
                                                    <div class="flex items-center">
                                                        <div class="w-3 h-3 rounded-full bg-red-500 mr-2"></div>
                                                        <div class="text-sm font-medium text-gray-900">At Risk</div>
                                                    </div>
                                                </td>
                                                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-700">Re-Engagement</td>
                                                <td class="px-6 py-4 whitespace-nowrap">
                                                    <span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">+6%</span>
                                                </td>
                                                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-700">Product G</td>
                                            </tr>
                                            <tr>
                                                <td class="px-6 py-4 whitespace-nowrap">
                                                    <div class="flex items-center">
                                                        <div class="w-3 h-3 rounded-full bg-gray-400 mr-2"></div>
                                                        <div class="text-sm font-medium text-gray-900">Hibernating</div>
                                                    </div>
                                                </td>
                                                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-700">Reactivation Campaign</td>
                                                <td class="px-6 py-4 whitespace-nowrap">
                                                    <span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">+4%</span>
                                                </td>
                                                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-700">Product H</td>
                                            </tr>
                                            <tr>
                                                <td class="px-6 py-4 whitespace-nowrap">
                                                    <div class="flex items-center">
                                                        <div class="w-3 h-3 rounded-full bg-gray-300 mr-2"></div>
                                                        <div class="text-sm font-medium text-gray-900">Others</div>
                                                    </div>
                                                </td>
                                                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-700">General Nurture</td>
                                                <td class="px-6 py-4 whitespace-nowrap">
                                                    <span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">+2%</span>
                                                </td>
                                                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-700">Product I</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div> */}
                                            

                            </div>
                            <ChartsDashboard blockData={blockData} totalCustomers={totalCustomers} blockValue={blockValue} />
                        </section>

                        <section class="mb-8">
                            <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
                                <div className="">
                                    {/* <h2 className="text-xl font-semibold text-gray-800 mb-4">Cluster Distribution</h2>
                            <div className="chart-container h-[500px]">
                                <ScatterChart rfmResponse={rfmResponse} />
                            </div>
                            <div className="mt-4 grid grid-cols-2 sm:grid-cols-4 gap-3 justify-center">
                                {clusterLabels.map((item, idx) => (
                                    <div key={idx} className="flex items-center text-xs">
                                        <div className={`w-3 h-3 rounded-full ${item.color} mr-2`}></div>
                                        {item.name}
                                    </div>
                                ))}
                            </div> */}


                                </div>



                                {/* <div class="bg-white rounded-xl shadow-sm p-6">
                            <h2 class="text-xl font-semibold text-gray-800 mb-4">Key Insights</h2>
                            <div class="space-y-4">
                                <div class="p-4 bg-blue-50 border-l-4 border-blue-500 rounded-r">
                                    <h3 class="font-semibold text-gray-800">Revenue Concentration</h3>
                                    <p class="mt-1 text-sm text-gray-600">
                                        <span class="font-bold">70% of total revenue</span> comes from Champions (42%) and Loyal Customers (28%)
                                        despite representing only 23% of all customers.
                                    </p>
                                </div>
                                <div class="p-4 bg-orange-50 border-l-4 border-orange-500 rounded-r">
                                    <h3 class="font-semibold text-gray-800">Vulnerability Alert</h3>
                                    <p class="mt-1 text-sm text-gray-600">
                                        The At Risk cluster represents 12% of revenue and has a 26% churn probability.
                                        <span class="font-bold">$1.2M in revenue is at risk</span> in the next quarter.
                                    </p>
                                </div>
                                <div class="p-4 bg-green-50 border-l-4 border-green-500 rounded-r">
                                    <h3 class="font-semibold text-gray-800">Automated Campaign Strategy</h3>
                                    <ul class="mt-1 text-sm space-y-2">
                                        <li class="flex items-start">
                                            <span class="text-green-500 mr-2">✓</span>
                                            <span><strong>Champions:</strong> VIP offers every 60 days</span>
                                        </li>
                                        <li class="flex items-start">
                                            <span class="text-green-500 mr-2">✓</span>
                                            <span><strong>At Risk:</strong> Win-back if no purchase in 60 days</span>
                                        </li>
                                        <li class="flex items-start">
                                            <span class="text-green-500 mr-2">✓</span>
                                            <span><strong>Hibernating:</strong> Reactivation after 180 days</span>
                                        </li>
                                    </ul>
                                </div>
                                <div class="p-4 bg-turq-50 border-l-4 border-turq-500 rounded-r">
                                    <h3 class="font-semibold text-gray-800">Cluster Movement</h3>
                                    <p class="mt-1 text-sm text-gray-600">
                                        8% of Loyal Customers are shifting toward the At Risk cluster.
                                        <span class="font-bold">Targeted intervention could prevent $45K in lost revenue.</span>
                                    </p>
                                </div>
                            </div>
                            <div class="mt-6">
                                <button class="w-full flex items-center justify-center gap-2 bg-gray-100 hover:bg-gray-200 text-gray-700 font-medium py-3 px-4 rounded-lg transition">
                                    <i class="fas fa-chart-line"></i> Generate Full Report
                                </button>
                            </div>
                        </div> */}
                            </div>
                        </section>
                    </>
                }

                {/* {
                    (subTabs !== "all") &&
                    <AtRisk subTabs={subTabs} rfmResponse={rfmResponse} filterRfmResponse={filterRfmResponse} />
                } */}
                {/* {
                    
                    <CustomerSegmentationTable subTabs={subTabs} rfmResponse={rfmResponse} filterRfmResponse={filterRfmResponse} />
                } */}
            </div>
        </>
    )
}

export default Kmeans;